import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16f06a57")

_pushScopeId("data-v-16f06a57")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-wrapper" }, [
  /*#__PURE__*/_createVNode("div", { class: "tips-wrapper" }, [
    /*#__PURE__*/_createVNode("div", { class: "tips-title" }, [
      /*#__PURE__*/_createVNode("span", null, "温馨提示")
    ]),
    /*#__PURE__*/_createVNode("p", null, " 网络质量会影响（答题）数据上传，进而影响得分，建议你在良好的网络环境下参与答题。 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "content-item-title" }, [
    /*#__PURE__*/_createVNode("span", null, "参赛资格")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "content-item" }, [
    /*#__PURE__*/_createVNode("p", null, "瘦吧注册用户每天登陆元宇宙即可答题机会。")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "content-item-title" }, [
    /*#__PURE__*/_createVNode("span", null, "规则说明")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "content-item" }, [
    /*#__PURE__*/_createVNode("p", null, "1、用户每天3次答题机会，每次答题题量不限；"),
    /*#__PURE__*/_createVNode("p", null, "2、用户答错题目马上结束答题，即答错了消耗一次答题机会。"),
    /*#__PURE__*/_createVNode("p", null, "3、用户每次连续答对5道题，即可获得1次抽奖机会；"),
    /*#__PURE__*/_createVNode("p", null, "4、每位用户每天最多3次抽奖机会；"),
    /*#__PURE__*/_createVNode("p", null, "5、每次答题时间为20秒，超过时间未答题作答错处理。"),
    /*#__PURE__*/_createVNode("p", null, "6、虚拟奖品将会在14个工作日内完成兑换。"),
    /*#__PURE__*/_createVNode("p", null, " 7、实体奖品将会在用户填写正确收件信息后，21个工作日内邮寄，如出现不可抗逆原因，则顺延。 ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, {
    circleRight: true,
    circleTop: true,
    flower: true,
    spot: true,
    starTop: true,
    starMiddle: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, {
          img: `${_ctx.rootUrl}/answer/answer_rule.png`
        }, null, 8, ["img"]),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
})